import useFetchGQLListTill from 'src/lib/graphql/hooks/useFetchGQLListTill';
import useQBankQuery from 'src/modules/exam-preparation/screens/Subject/container/QBankTab/useQBankQuery';
export default function useQBankQuestionSiblings(params, till) {
    const [qBankQueryState, qBankQueryActions] = useQBankQuery(params.filters);
    const [siblingQueryState] = useFetchGQLListTill(qBankQueryState.listQuery, qBankQueryActions, qBankQueryState.listQueryVars, till, !params?.filters?.ancestorID);
    const state = siblingQueryState;
    const actions = {};
    return [state, actions];
}
